import {
  BasePageMetaResolver,
  PageLinkService,
  ProductPageMetaResolver,
  ProductService,
  RoutingService,
  TranslationService,
  WindowRef
} from '@spartacus/core'
import { Injectable } from '@angular/core'
import { CurrentProductService } from '@spartacus/storefront'
import { map, switchMap } from 'rxjs/operators'
import { MbBasePageMetaResolver } from '../../cms/page/mb-base-page-meta-resolver'
import { environment } from '../../../../environments/environment'
import { CaasIdType } from '../../cms/enums/caas-id-types'
import { MbCaasService } from '../../cms/services/mb-caas/mb-caas.service'
import { MbBreadcrumbService, PathNodesBreadcrumbModel } from '../../cms/services/mb-breadcrumb/mb-breadcrumb.service'
import { MbNavigationService } from '../../cms/navigation/mb-navigation.service'
import { MbConstants } from '../../shared/mb-constants'
import { CountryService } from '../../site-context/facade/country.service'
import { CmsCountryService } from '../../cms/services/cms-country/cms-country.service'
import { of } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class MiltenyiProductPageMetaResolver extends ProductPageMetaResolver {

  constructor (routingService: RoutingService,
              productService: ProductService,
              translation: TranslationService,
              basePageMetaResolver: BasePageMetaResolver,
              pageLinkService: PageLinkService,
              private currentProductService: CurrentProductService,
               private mbBasePageMetaResolver: MbBasePageMetaResolver,
               private caasService: MbCaasService,
               private breadcrumbService: MbBreadcrumbService,
               private mbNavigationService: MbNavigationService,
               private countryService: CountryService,
               private cmsCountryService: CmsCountryService,
              protected winRef: WindowRef) {
    super(routingService, productService, translation, basePageMetaResolver, pageLinkService)
  }

  resolveRobots () {
    return this.mbBasePageMetaResolver.resolveRobots()
  }

  resolveTitle () {
    return this.currentProductService.getProduct().pipe(
      map(product => product?.seoTitle),
      switchMap(seoTitle => seoTitle ? of(seoTitle) : this.getFallBackTitle())
    )
  }

  resolveBreadcrumbs () {
    return this.currentProductService.getProduct().pipe(
      switchMap(product => {
        const categoryId = `${environment.occ.productCatalog}/${product?.categories?.[0]?.code}`
        return this.caasService.getByIds([categoryId], CaasIdType.CATEGORY).pipe(
          map(productPage =>
            this.breadcrumbService.getPathNodes(this.mbNavigationService.resolvedIdMap.value, productPage?.[0]?.identifier ?? '')
          ),
          map(({ pathNodes,currentNode, currentPagePreviewId }: PathNodesBreadcrumbModel) =>
            this.breadcrumbService.addCurrentPageToPathNodes(pathNodes, currentNode, currentPagePreviewId, product)
          ),
          switchMap(({ pathNodes, currentNode, currentPagePreviewId }) =>
            this.breadcrumbService.getHideAndShortenBreadcrumbsForPathNodes(pathNodes, currentPagePreviewId, currentNode)
          ),
          map(({ pathNodes, currentNode }) => this.breadcrumbService.mapPathNodesToBreadcrumbs(pathNodes, currentNode, product)),
        )
      })
    )
  }

  resolveDescription () {
    return this.currentProductService.getProduct().pipe(
      map(product => product?.seoDescription || '')
    )
  }

  private getFallBackTitle () {
    return this.countryService.getActive().pipe(
      map(activeCountry =>
        this.cmsCountryService.getCountryByISO(activeCountry)
      ),
      map(country => ` | ${MbConstants.PAGE_TITLE_MILTENYI_SUFFIX} | ${country?.nationalName}`),
      switchMap(suffix => this.resolveBreadcrumbs().pipe(
        map(breadcrumbs => breadcrumbs.reverse().map(breadcrumb => breadcrumb.label).join(' | ')),
        // return reversed breadcrumb as title with suffix if meta title not present used as a fallback title
        map(breadcrumbsTitle => `${breadcrumbsTitle}${suffix}`)
      )),
    )
  }
}
